import React from "react";

export default function RemoveAccount() {
    return (
        <div style={styles.container}>
            <h1>Remove Account</h1>

            <p>
                HomeApp allows users to remove their account and associated personal data.
            </p>

            <h3>How to remove your account</h3>
            <ol>
                <li>Open the HomeApp mobile application</li>
                <li>Go to <strong>Settings</strong></li>
                <li>Select <strong>Delete Account</strong></li>
                <li>Confirm the deletion</li>
            </ol>

            <p>
                If you cannot access the app, you may request account removal by contacting:
                <br />
                <strong>admin@soukakarat.com</strong>
            </p>

            <h3>Data removed</h3>
            <ul>
                <li>User account</li>
                <li>Profile information</li>
            </ul>
            
            <p>
                Account removal requests are processed instantly.
            </p>
        </div>
    );
}

const styles = {
    container: {
        maxWidth: 720,
        margin: "40px auto",
        padding: 24,
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.6,
    },
};